import React from 'react';
import { MdCheckCircle, MdCancel, MdHotel } from 'react-icons/md';

const estadosConfig = {
  asistio: {
    label: 'Asistieron',
    icon: MdCheckCircle,
    color: 'bg-gradient-to-r from-green-400 to-green-600 dark:from-green-500 dark:to-green-700',
  },
  falto: {
    label: 'Faltaron',
    icon: MdCancel,
    color: 'bg-gradient-to-r from-red-500 to-red-600 dark:from-red-600 dark:to-red-700',
  },
  descanso: {
    label: 'Descansaron',
    icon: MdHotel,
    color: 'bg-gradient-to-r from-amber-400 to-amber-500 dark:from-amber-500 dark:to-amber-600',
  },
};

const AsistenciaStateTag = ({ usuarios = [] }) => {
  const counts = {
    asistio: 0,
    falto: 0,
    descanso: 0,
  };

  usuarios.forEach(({ estado }) => {
    const key = estado?.toLowerCase();
    if (key in counts) {
      counts[key]++;
    }
  });

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(estadosConfig).map(([key, { label, icon: Icon, color }]) => (
        <div
          key={key}
          className={`text-sm font-bold ${color} text-white py-1 px-3 rounded-xl inline-flex items-center gap-2 shadow-md w-fit`}
        >
          <Icon size={18} />
          <span>{label}:</span>
          <span>{counts[key]}</span>
        </div>
      ))}
    </div>
  );
};

export default AsistenciaStateTag;
